app.factory('gameDayAuthService', ['$window',function ($window) {
	var service = this;

	service.keyString = function() {
		var cookie = $window.document.cookie;
		if (!cookie) {
			return null;
		}
		var idx = cookie.indexOf(".FDGAMEDAY=");
		if (idx < 0) {
			return null;
		}
		var sub = cookie.substring(idx);
		var end = sub.indexOf("; ");
		var key = sub;
		if (end != -1) {
			key = key.substring(0, end);
		}
		return key.substr(".FDGAMEDAY=".length);
	}

	service.isAuthenticated = function() {
		return service.keyString() != null;
	}

	return service;
}]);